import { render } from "./CreatingUser.vue?vue&type=template&id=7c0db3d0"
import script from "./CreatingUser.vue?vue&type=script&lang=js"
export * from "./CreatingUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__